// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function FileSigned(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "FileSigned" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3V21H19V7L14 3H5ZM8 7.5H11V6H8V7.5ZM16 10.5H8V9H16V10.5ZM13.0204 15L11.5607 17.047L10.5494 15.9965L9.65195 17.3949H8V18.652H10.3295L10.745 18.0047L11.7032 19L12.8694 17.3645L13.558 18.652H17V17.3949H14.3012L13.0204 15ZM8 13.5H16V12H8V13.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=FileSigned.js.map